// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"277":"771a4483","471":"c5886ff2"}[chunkId] + ".chunk.js";
};